module.exports = {
	'CREATED': 'created',
	'DEFINED': 'defined',
	'LOADED': 'loaded',
	'RENDERED': 'rendered',
	'ERROR': 'error'
};
